import { iconStroke, iconViewBox, icons, type IconName } from '@tira/design-tokens/icons';
import type { JSX } from 'react';
import './Icon.css';

export type { IconName };

export interface IconProps {
  name: IconName;
  /** px. The set is drawn on a 24 grid, so stroke weight scales with this. */
  size?: number;
  /**
   * Supply only when the icon carries meaning nothing else on screen carries.
   * Decorative icons beside a label stay hidden from the accessibility tree.
   */
  label?: string;
  className?: string;
}

export function Icon({ name, size = 20, label, className }: IconProps): JSX.Element {
  return (
    <svg
      className={className === undefined ? 'icon' : `icon ${className}`}
      viewBox={iconViewBox}
      width={size}
      height={size}
      fill={iconStroke.fill}
      stroke={iconStroke.stroke}
      strokeWidth={iconStroke.strokeWidth}
      strokeLinecap={iconStroke.strokeLinecap}
      strokeLinejoin={iconStroke.strokeLinejoin}
      role={label === undefined ? undefined : 'img'}
      aria-label={label}
      aria-hidden={label === undefined ? true : undefined}
      focusable="false"
      // Paths are authored data from the token package, never user input.
      dangerouslySetInnerHTML={{ __html: icons[name] }}
    />
  );
}
